const shell = {
  projectSyncError: '暂时无法读取企业项目，请检查网络后重试。',
  retry: '重新尝试',
  projectSwitcher: '项目切换器',
  switchWorkspace: '切换企业空间',
  home: 'Navigator 首页',
  project: '项目',
  currentProject: '当前项目',
  newProject: '建立新项目',
  navigation: '一级导航',
  nav: {
    memory: '记忆',
    diagnosis: '诊断',
    action: '行动',
    presence: '阵地',
    results: '结果',
  },
  appearance: '外观',
  themeButtonLabel: '外观 · {theme}',
  settings: '设置',
  settingsIntro: '管理界面、企业空间与项目偏好。',
  personal: '个人',
  workspace: '企业空间',
  projectSettings: '项目',
  interfaceLanguage: '界面语言',
  interfaceLanguageHint: '只切换 Navigator 控件；企业真值与证据原文保持原语言。',
  followSystem: '跟随系统',
  theme: '主题',
  themeSystem: '跟随系统',
  themeLight: '浅色',
  themeDark: '深色',
  close: '关闭',
  vaultConnected: '项目空间已就绪',
  workspaceSettingsIntro: '管理这家企业共享的空间偏好。',
  membersEyebrow: '企业级访问控制',
  membersTitle: '成员与权限',
  membersIntro: '决定哪些工作邮箱可以进入这个企业空间，以及每位成员能够承担什么工作。',
  membersScope: '权限适用于当前企业空间内的全部项目。',
  activeMembers: '名有效成员',
  memberRoles: { tenant_admin: '企业管理员', operator: '运营人员', member: '成员' },
  memberRoleShort: {
    tenant_admin: '管理成员、设置和全部运营工作。',
    operator: '处理线索、分配负责人和记录跟进。',
    member: '使用企业项目并处理分配给自己的工作。',
  },
  memberRoleDetail: {
    tenant_admin: '可以管理成员和设置、进入运营视图，并把线索分配给其他成员。',
    operator: '可以进入运营视图、处理线索，并把线索分配给有效成员。',
    member: '可以使用企业项目，并处理分配给自己的工作；不能管理成员。',
  },
  memberStatuses: { active: '有效', revoked: '已停用' },
  memberList: '企业成员',
  memberFilter: '成员筛选',
  addMember: '添加成员',
  manageMember: '管理',
  currentAccount: '当前账号',
  noMembers: '当前状态下没有成员。',
  membersLoading: '正在读取企业成员…',
  membersLoadFailed: '暂时无法读取企业成员。',
  memberBoundaryTitle: 'V1 权限边界：',
  memberBoundaryBody: '这里管理企业级访问，不建立部门或项目级权限。被停用成员的现有登录会话会立即失效。',
  memberPermissionTitle: '只有企业管理员可以管理成员。',
  memberPermissionBody: '你当前的访问权限不会改变。',
  addMemberTitle: '添加企业成员',
  addMemberIntro: '把一个工作邮箱加入当前企业空间。',
  editMemberTitle: '管理成员',
  editMemberIntro: '角色变化将在保存后立即生效。',
  workEmail: '工作邮箱',
  memberEmailHint: '添加后，对方即可在登录页申请一次性安全链接。',
  accessRole: '访问权限',
  memberLastAdminTitle: '最后一名管理员不能被降级或停用。',
  memberLastAdminBody: '请先添加另一名企业管理员。',
  memberSelfGuard: '当前管理员不能修改自己的访问权限。',
  deactivateMember: '停用访问',
  restoreMember: '恢复访问',
  saveMember: '保存更改',
  savingMember: '正在保存…',
  cancel: '取消',
  memberAdded: '成员已添加。',
  memberSaved: '成员权限已更新。',
  memberRevoked: '成员访问已停用。',
  memberRestored: '成员访问已恢复。',
  memberExists: '这个邮箱已经在企业空间中。',
  memberSaveFailed: '成员变更未能保存。',
  projectSettingsIntro: '管理只对当前项目生效的偏好。',
  defaultOutputLanguage: '默认工作与报告语言',
  defaultOutputLanguageHint: '诊断报告、策略及其他项目 AI 调用会把它作为具体 output_language 发送；不会改变界面语言。',
  targetContentLanguages: '目标内容语言',
  targetContentLanguagesHint: '选择一种或多种面向市场的生产语言；单次任务以后仍可覆盖项目默认值。',
  saveLanguageSettings: '保存语言设置',
  savingLanguageSettings: '正在保存…',
  languageSettingsSaved: '已保存',
  languageSettingsFailed: '保存失败，生产设置仍保持原值。',
  leadSlaTenantTitle: '企业线索响应规则',
  leadSlaTenantHint: '设定企业项目默认采用的线索响应时限；项目可以继承、覆盖或停用。',
  leadSlaProjectTitle: '项目线索响应规则',
  leadSlaProjectHint: '决定当前项目继承企业规则、使用独立规则，还是停用后续计时。',
  leadSlaLoading: '正在读取当前响应规则…',
  leadSlaEffective: '当前生效',
  leadSlaEnabled: '已启用',
  leadSlaDisabled: '已停用',
  leadSlaEffectiveSource: '来源：{source} · 规则 revision {revision}',
  leadSlaSourceTenant: '企业规则',
  leadSlaSourceProject: '项目规则',
  leadSlaSourceNone: '尚无规则',
  leadSlaMode: '当前层级',
  leadSlaModes: { policy: '使用独立规则', disabled: '停用', inherit: '继承企业规则' },
  leadSlaClockMode: '计时方式',
  leadSlaClockElapsed: '连续时间',
  leadSlaClockBusiness: '仅工作时段',
  leadSlaTimezone: '时区',
  leadSlaFirstResponse: '首次响应（分钟）',
  leadSlaFollowup: '后续跟进（分钟）',
  leadSlaWarning: '提前提醒（分钟）',
  leadSlaBusinessDays: '工作日',
  leadSlaWeekdays: { 0: '周一', 1: '周二', 2: '周三', 3: '周四', 4: '周五', 5: '周六', 6: '周日' },
  leadSlaBusinessStart: '开始时间',
  leadSlaBusinessEnd: '结束时间',
  leadSlaAdminOnly: '只有企业管理员可以修改这项设置。',
  leadSlaValidation: '请完整填写规则；提醒时间必须短于首次响应和后续跟进时限。',
  leadSlaSave: '保存响应规则',
  leadSlaSaving: '正在保存…',
  leadSlaSaved: '响应规则已保存',
  leadSlaSaveFailed: '保存失败，请重新读取后再试。',
  leadSlaUnavailable: '暂时无法读取当前响应规则。',
  leadSlaNoScope: '当前企业或项目尚不可用。',
  leadSlaClockBoundary: '设置变更不会改写正在运行的计时：当前阶段按启动时规则结算；停用后不再开启下一阶段，继承后下一阶段采用届时生效的企业规则。',
  airlockAppearance: '网站 Airlock 外观',
  airlockAppearanceHint: '设置部署在客户网站上的接待模块外观，不会改变 Navigator 自身界面。',
  airlockLoading: '正在读取网站当前外观…',
  airlockPreviewEyebrow: '网站接待',
  airlockPreviewTitle: '有什么可以帮你？',
  airlockPreviewBody: '保存前预览获准使用的颜色、圆角与字体。',
  airlockPreviewAction: '开始交流',
  airlockColorScheme: '深浅模式',
  airlockScheme: { auto: '跟随访客设备', light: '始终浅色', dark: '始终深色' },
  airlockColors: '品牌色彩',
  airlockColorsHint: '保留“网站默认”时，Airlock 会使用经过验证的安全默认值。',
  airlockAccent: '主操作按钮',
  airlockOnAccent: '主按钮文字',
  airlockSurface: '主背景',
  airlockSurfaceAlt: '次级背景',
  airlockText: '主要文字',
  airlockMuted: '辅助文字',
  airlockLine: '边框与分隔线',
  airlockInherit: '网站默认',
  airlockUseDefault: '使用默认',
  airlockCornerRadius: '圆角大小',
  airlockFont: '字体',
  airlockFontHost: '跟随网站',
  airlockFontSans: 'Navigator 无衬线',
  airlockFontSerif: 'Navigator 衬线',
  airlockSave: '保存 Airlock 外观',
  airlockSaving: '正在保存…',
  airlockSaved: '网站外观已保存',
  airlockSaveFailed: '保存失败，请重新读取当前设置后再试。',
  airlockUnavailable: '这个项目暂时没有可用的网站外观设置。',
  airlockRetry: '重新读取',
  airlockBoundary: '这里只接受获准的颜色、圆角、字体与深浅模式；不能输入自定义 CSS、网址或脚本。',
  subscription: '订阅与计费',
  billingLoading: '正在读取订阅状态…',
  billingUnavailable: '暂时无法使用订阅计费服务。',
  billingEyebrow: '领航者计费 · Stripe 沙盒',
  billingTitle: '套餐与订阅',
  billingIntro: '为当前企业空间选择持续运行的产能。领航者能力会持续进化；套餐划分的是使用容量，不是被写死的功能清单。',
  billingSandbox: '测试模式 · 不会正式扣款',
  billingEnterprise: '付费企业空间',
  billingCurrent: '当前订阅',
  billingStatus: {
    AWAITING_PAYMENT: '等待付款完成',
    ACTIVE: '生效中',
    CANCEL_AT_PERIOD_END: '本周期结束后停止',
    PAST_DUE: '付款逾期',
    EXPIRED: '已到期',
    REFUNDED: '已退款',
  },
  billingPeriodEnd: '当前周期至 {date}',
  billingNoSubscription: '当前企业空间还没有生效中的订阅。',
  billingInterval: '付款周期',
  billingMonthly: '按月付费',
  billingAnnual: '按年付费',
  billingAnnualPromo: '付 10 个月，使用 12 个月',
  billingPlan: {
    launch: '适合开始建立持续增长循环的小型团队。',
    growth: '适合持续拓展市场与工作循环的成长型团队。',
    scale: '适合更高业务规模与复杂协作的组织。',
    enterprise: '按合同单独约定价格、部署边界与服务条件。',
  },
  billingMonthUnit: '月',
  billingYearUnit: '年',
  billingStartCheckout: '前往安全支付',
  billingRedirecting: '正在打开支付页…',
  billingCustom: '按需定价',
  billingContractOnly: '联系我们',
  billingAdminOnly: '只有企业空间管理员可以发起订阅。',
  billingExistingGuard: '当前空间已有订阅；沙盒阶段暂不开放自助改档与取消。',
  billingCheckoutFailed: '未能打开支付页面，订阅状态没有发生变化。',
  billingBoundary: '当前仅为测试环境。企业身份取自已登录的 Navigator 会话，价格取自锁定的沙盒价目表；浏览器不能改写这两项。',
  billingUsageEyebrow: '容量观察',
  billingUsageTitle: '本周期业务用量',
  billingUsageObserveOnly: '当前只记录内测研究值，达到参考线也不会停机、降级或自动扣费。',
  billingUsageCounter: {
    completed_cycle: '完成周期',
    standard_artifact: '标准成果',
    localization_version: '本地化版本',
    publication_position: '新增发布位置',
    airlock_conversation: 'Airlock AI 会话',
  },
  billingUsageBreakdown: '已用 {used} · 在途 {inFlight} · 待队列 {queued}',
  billingUsageNotConnected: '数据尚未接通',
  billingUsageNotConnectedDetail: '接通可信业务来源后，才会显示真实用量。',
  billingUsageBoundary: '斜线后的数字是 Sandbox 观察锚点，不是正式客户合同额度。',
  outputLanguageBoundary: '语言选择权属于 Navigator；Foundry 每次只接收一个具体的 BCP-47 output_language，不定义全局默认语言。',
  settingsBoundary: '这里承载面向客户的应用设置与企业访问权限；内部运营和系统控制仍由独立控制端负责。',
  settingsDeferred: '设置入口与所有权边界已经就位；具体字段只在生产契约批准后接入。',
  signedInAs: '当前登录邮箱',
  signOut: '退出登录',
  signingOut: '正在退出…',
  signOutFailed: '退出失败，请检查网络后重试。',
  surfacePendingEyebrow: '全局壳 · 页面接线',
  surfacePendingTitle: '{route}页面正在接入',
  surfacePendingBody: '导航、语言与设置边界已经就位；本页将在对应页面批次中接入正式内容。',
} as const

export default shell
